import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom'

import { useAppState } from "./../../state";

import ToggleFeatureFlagsPage from "./ToggleFeatureFlags/ToggleFeatureFlagsPage"


// react-bootstrap components
import {
    Button,
    Card,
    Container,
    Row,
    Col,
    Spinner
} from "react-bootstrap";

import "./FeatureFlagPage.scss";

function FeatureFlagPage(props) {
    const [errorMessage, setErrorMessage] = useState();
    const [cardCSSClass, setCardCSSClasses] = useState("");

    const [featureFlags, setFeatureFlags] = useState([]);

    const location = useLocation();

    const { user, app, onAppStateRefresh } = useAppState();
    
    return (
        <>
            <Container fluid id="featureFlagPage">
                <Card className="bg-white border-0">
                    <Card.Body>
                        <ToggleFeatureFlagsPage />
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}

export default FeatureFlagPage;